import * as React from 'react';
import { connect } from 'react-redux';
import { Box } from '../../atoms/box';
import { Text } from '../../atoms/text';
import { Trans, withTranslation } from 'react-i18next';
import { select } from '@rematch/select';
import { CSSTransition, TransitionGroup } from 'react-transition-group';
import { Link } from 'react-router-dom';

import { AppLayout } from '../../layouts/AppLayout';
import { CategoriesCardList } from '../../atoms/categories-card-list';
import { dispatch } from '../../store';
import { ThemeConsumer } from '../../atoms/theme';
import { SegmentedControl } from './SegmentedControl';
import { CommunityCard } from '../../atoms/community-card/CommunityCard';
import { getAppConfig } from '../../atoms/app-config-gate';
import { Loader } from '../../atoms/loader';
import { OrganizationModalDeprecated } from '../../atoms/organization-modal';
import { CommunityService } from '../../services/CommunityService';
import { can } from '../../utils/permissions';

export class PageNetworkRenderer extends React.Component {
  state = {
    isOrganizationPreviewModalOpen: false,
  };

  SCOPE = (() => {
    const featureFlags = getAppConfig().feature_flags;
    const tabs = featureFlags?.explore_branded_app
      ? [
          { value: 'joined', title: this.props.t('My Communities'), scope: 'joined', id: 'tab-my-communities' },
          {
            value: 'branded',
            title: this.props.t('brandedCommunities', { brandedName: this.props.brandedOrganization?.name }),
            scope: 'branded',
            id: 'tab-explore-branded-communities',
          },
          {
            value: 'explore',
            title: this.props.t('Explore BigHeart Network Communities'),
            scope: 'explore',
            id: 'tab-explore-communities',
          },
        ]
      : [
          { value: 'joined', title: this.props.t('My Communities'), scope: 'joined', id: 'tab-my-communities' },
          {
            value: 'explore',
            title: this.props.t('Explore BigHeart Network Communities'),
            scope: 'explore',
            id: 'tab-explore-communities',
          },
        ];

    return tabs;
  })();

  componentDidMount = () => {
    if (this.props.brandedOrganizationId && !this.props.brandedOrganization) {
      this.props.fetchOrganization(this.props.brandedOrganizationId);
    }

    this.fetchData();
  };

  componentDidUpdate(prevProps) {
    if (prevProps.scope !== this.props.scope) {
      this.fetchData();
    }
  }

  fetchData = () => {
    if (this.props.scope === 'explore') {
      this.fetchCategories();
    } else {
      this.fetchCommunities();
    }
  };

  fetchCategories = async () => {
    dispatch.categories.getAsync({ type: 'organization' });
  };

  fetchCommunities = () => {
    this.props.scope === 'joined'
      ? dispatch.communities.joinedAsync()
      : dispatch.communities.notJoinedAsync(getAppConfig().organization);
  };

  onCommunityClick = (id) => {
    this.props.history.push(`/communities/${id}/feed`);
  };

  onBrandedCommunityClick = (community) => {
    if (can(community, 'Community', 'joined')) {
      return false;
    }

    this.setState({
      selectedCommunityForPreview: community,
      isOrganizationPreviewModalOpen: true,
    });

    return true;
  };

  onRequestClose = () => {
    this.setState({
      selectedCommunityForPreview: null,
      isOrganizationPreviewModalOpen: false,
    });
  };

  renderGroup = ([organization, communities]) => {
    return (
      <ThemeConsumer key={organization.id}>
        {(theme) => (
          <React.Fragment>
            <div className="group__title">
              <Text size={24} lineHeight="18px" color={theme.color.brand} weight="700" component="div">
                {organization.name}
              </Text>
            </div>
            <div className="row group__items-wrapper group__items-wrapper--community">
              {communities.map((community) => (
                <Link key={community.id} to={`/communities/${community.id}/feed`}>
                  <CommunityCard community={community} className="card__group" />
                </Link>
              ))}
            </div>
          </React.Fragment>
        )}
      </ThemeConsumer>
    );
  };

  renderBranded = ([organization, communities]) => {
    return (
      <ThemeConsumer key={organization.id}>
        {(theme) => (
          <React.Fragment>
            <Text color="#A2ABBB" size={17}>
              <Trans>Explore the communities you are not a member of</Trans>
              <span> {organization.name}</span>
            </Text>
            <TransitionGroup className="row" style={{ marginBottom: 32 }}>
              {communities.map((community) => (
                <CSSTransition key={community.id} timeout={400} classNames="fade">
                  <div className="col-md-6 col-sm-6 col-xs-6 branded-pill">
                    <CommunityCard
                      community={community}
                      onClick={() => this.onBrandedCommunityClick(community)}
                      className="card__branded"
                    />
                  </div>
                </CSSTransition>
              ))}
            </TransitionGroup>
          </React.Fragment>
        )}
      </ThemeConsumer>
    );
  };

  header = () => {
    return (
      <ThemeConsumer>
        {(theme) =>
          !theme.isBranded ? (
            <Box>
              <Text color={theme.color.brand} size={28} weight="700" style={{ marginBottom: 16 }}>
                <Trans>What type of nonprofit are you looking for?</Trans>
              </Text>
              <Text color={theme.color.lightGray} size={17}>
                <Trans>Select category to get started</Trans>
              </Text>
            </Box>
          ) : null
        }
      </ThemeConsumer>
    );
  };

  joinedCommunities = () => {
    const { communitiesGroupedByOrganization } = this.props;
    communitiesGroupedByOrganization.sort((a, b) => {
      return a[0].name.localeCompare(b[0].name);
    });

    return (
      <ThemeConsumer>
        {(theme) =>
          communitiesGroupedByOrganization.length ? (
            <div>
              <Box style={{ marginTop: 32 }}>
                <Text color="#A2ABBB" size={17}>
                  <Trans>Please select a community you want to go to</Trans>
                </Text>
              </Box>
              <Box flexDirection="column">
                {communitiesGroupedByOrganization.map((group) => this.renderGroup(group))}
              </Box>
            </div>
          ) : null
        }
      </ThemeConsumer>
    );
  };

  onCommunitiesExploring = async (community) => {
    window.location.href = `/communities/${community.id}`;
  };

  brandedCommunities = () => {
    const { communitiesGroupedByOrganization } = this.props;

    return (
      <ThemeConsumer>
        {(theme) =>
          communitiesGroupedByOrganization.length ? (
            <div>
              <Box style={{ marginTop: 32 }}>
                <Text color={theme.color.brand} size={28} style={{ fontWeight: 'bold', marginBottom: 16 }}>
                  <Trans>Explore more communities</Trans>
                </Text>
                {communitiesGroupedByOrganization.map((group) => this.renderBranded(group))}
              </Box>
            </div>
          ) : null
        }
      </ThemeConsumer>
    );
  };

  onCommunityJoinNow = async (community, params) => {
    await CommunityService.join(community.id, params);

    await dispatch.session.fetchUser();
  };

  render() {
    const { explore_branded_app } = getAppConfig().feature_flags;
    return (
      <AppLayout
        center={
          <ThemeConsumer>
            {(theme) => (
              <React.Fragment>
                <div>
                  <SegmentedControl
                    id="communities-tabs"
                    labels={this.SCOPE}
                    selectedLabel={this.props.scope}
                    onChange={(label) => {
                      this.props.history.push(`/network/${label}`);
                    }}
                  />
                </div>
                {!this.props.loading ? (
                  <div style={{ paddingTop: 15 }}>
                    {this.props.scope === 'joined' ? (
                      this.joinedCommunities()
                    ) : this.props.scope === 'branded' && explore_branded_app ? (
                      this.brandedCommunities()
                    ) : (
                      <CategoriesCardList header={this.header} type="organization" />
                    )}
                  </div>
                ) : (
                  <Loader />
                )}
                <OrganizationModalDeprecated
                  isOpen={!!this.state.isOrganizationPreviewModalOpen}
                  onRequestClose={this.onRequestClose}
                  onRequestToJoin={() => {}}
                  onJoinNow={this.onCommunityJoinNow}
                  type={'community'}
                  data={this.state.selectedCommunityForPreview}
                  onExploring={this.onCommunitiesExploring}
                  onCommunityClick={this.onCommunityClick}
                />
              </React.Fragment>
            )}
          </ThemeConsumer>
        }
      />
    );
  }
}

const mapState = (state, props) => ({
  scope: props.match.params.scope,
  loading: state.loading.models.communities,
  communitiesGroupedByOrganization: select.communities.groupBy(state, 'organization'),
  brandedOrganizationId: getAppConfig().organization?.id,
  brandedOrganization: getAppConfig().organization && select.organizations.find(state, getAppConfig().organization.id),
});

const mapDispatch = (dispatch) => ({
  fetchOrganization: (id) => dispatch.organizations.findAsync(id),
});

export const PageNetwork = withTranslation()(connect(mapState, mapDispatch)(PageNetworkRenderer));
